<template>
  <BaseListV2
    :model-class="ClientApp"
    :collection-filter="filter"
    :can-reorder="true"
    help-message="Client apps are collections of views and functions. They are used to grant a customized frontend to the user."
  />
</template>

<script setup lang="ts">
import { useStore } from 'vuex'

import BaseListV2 from '@/components/common/BaseListV2.vue'
import { ClientApp } from '@/models/client/models'
const store = useStore()
const filter = {
  organisation: store.getters['global/organisation'].id,
}
</script>

<style></style>
